import { render } from "./membercard.vue?vue&type=template&id=11da36f6&scoped=true"
import script from "./membercard.vue?vue&type=script&lang=js"
export * from "./membercard.vue?vue&type=script&lang=js"

import "./membercard.vue?vue&type=style&index=0&id=11da36f6&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11da36f6"]])

export default __exports__